import type { FaireProductEntity } from "../../entity_types/product";

export const p_yqrut45fgr: FaireProductEntity = {
  token: "p_yqrut45fgr",
  type: "product",
  name: "Black Bandana Zip Sweater",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/52ad680f78c12da276eca7343215054333aa79571420058a8e069543cf4608d7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4843832b2bc5eef58ebfed57d1b9a5dd0acc4e70a827ac0802ca46216154b58c.jpeg",
    "https://cdn.faire.com/fastly/2b580929e944e4bc145c96055c5d84d402d8e81d26bde48b1282c8de2ee6d35a.jpeg",
    "https://cdn.faire.com/fastly/c4dcfe6d952089a3a65de7ee3c562ac3e535c41f9398ccbd7c764a77be56a6f3.jpeg",
    "https://cdn.faire.com/fastly/03dedfcc5ec6243a84179d7d35e6548e73b20ebaf734322a884d00e27af32138.jpeg"
  ],
  priceDollars: 33.95,
  description: "Black Bandana Zip Sweater featuring an allover black bandana-inspired pattern, designed with a classic collar, front zip closure, two front pockets, long sleeves, and a relaxed fit in a soft knit fabric for casual everyday wear or layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:53.981Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
